/*
 * Copyright (c) 2026. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import { Box } from '@mui/material';
import { alpha } from '@mui/material/styles';

function LauncherShortcutHint({ label, active }: Readonly<{ label: string; active: boolean }>) {
  return (
    <Box
      component="span"
      aria-hidden="true"
      data-testid="agent-launcher-shortcut"
      data-active={active}
      sx={{
        display: 'grid',
        gridTemplateColumns: active ? '1fr' : '0fr',
        ml: active ? 0 : '-7px',
        opacity: active ? 1 : 0,
        transform: active ? 'translateX(0)' : 'translateX(4px)',
        pointerEvents: 'none',
        transition:
          'grid-template-columns 120ms, margin-left 120ms, opacity 120ms, transform 120ms',
        '@media (prefers-reduced-motion: reduce)': { transition: 'none' },
      }}
    >
      <Box component="span" sx={{ minWidth: 0, overflow: 'hidden', display: 'flex' }}>
        <Box
          component="span"
          sx={(theme) => ({
            px: '6px',
            py: '2px',
            borderRadius: '999px',
            border: `1px solid ${alpha(theme.palette.primary.main, 0.6)}`,
            bgcolor: alpha(theme.palette.primary.main, 0.12),
            color: 'primary.main',
            fontSize: 10,
            lineHeight: '12px',
            fontWeight: 700,
            letterSpacing: '0.4px',
          })}
        >
          {label}
        </Box>
      </Box>
    </Box>
  );
}

export default LauncherShortcutHint;
